<template>
<div class="container-fluid">
  <div class="row">
    
      <button   @click="$emit('close')" type="button"  class="btn btn-secondary btn-block border border-info ">
        <i style="color:yellow" class="fas fa-reply mr-2"></i>
        RITORNA A PARAMETRI RICERCA
      </button>    
    


      <button   @click="exportToCSV()"  type="button" class="btn btn-light btn-block border border-info mb-1">
                  <i class="fas fa-file-export mr-2" aria-hidden="true"></i>
                  ESPORTA CSV ARTICOLI 
                  <span v-if="spinnerCSV"  class="spinner-border spinner-border-sm ml-2 " role="status" aria-hidden="true"></span>
      </button> 

    


  </div>
 

  
<div class="row">
<div class="col-8">


<div class="table-wrapper-scroll-y my-custom-scrollbar" id="table_div">
<table id='my-table' class="table table table-hover table-sm table-bordered mb-0">
  <thead >
    <tr class="table-primary">

      <th scope="col">DATA</th>
      <th scope="col">STAGIONE</th>
      <th scope="col">BRAND</th>      
      <th scope="col">CATEGORIA</th>
      <th scope="col">REPARTO</th>
      <th scope="col">CODICE</th>


      <th class="text-nowrap" scope="col">EAN GESTIONALE</th>
      <th scope="col">COLORE</th>
      <th scope="col">MISURA</th>
      <th class="text-nowrap" scope="col">PREZZO DI ACQUISTO</th>
      <th class="text-nowrap" scope="col">PREZZO RETAIL</th>
      <th class="text-nowrap" scope="col">% SCONTO</th>
   
      <th class="text-nowrap" scope="col">PREZZO DI VENDITA</th>
      <th scope="col">STORE</th>
      <th scope="col">MARKET</th>
      <th class="text-nowrap" scope="col">EAN FORNITORE</th>
      <th scope="col">NAZIONALITA'</th>
      <th scope="col">ORDINE</th>

      
         
    </tr>
  </thead>
  <tbody>
    <tr :style="{backgroundColor: item.Qta == -1 ? '#F1F1F1':'white', color: item.Qta == -1  ? 'red' : 'black',fontSize: item.Qta == -1 ? '':'',fontWeight:item.Qta == -1 ? '':'normal' }"   data-toggle="tooltip" title="" class="pointer"  v-for="(item, index) in filteredProducts" :key="index">
      

      <td class="text-nowrap">{{item.DataDiVendita}} </td>  
      
      <td >{{item.Stagione}} {{item.Anno}} </td>  
      <td class="text-nowrap" >{{item.Brand}}</td>    
      <td class="text-nowrap">{{item.Categoria}} </td>
      <td>{{item.Reparto}} </td>
      <td class="text-nowrap" >{{item.Codice}} </td>
      <td>{{item.Ean}} </td>
      <td class="text-nowrap">{{item.Colore}} </td>
      <td>{{item.Misura}} </td>
      <td class="text-right">{{fmt1(item._PrezzoDiAcquisto)}} </td>
      <td class="text-right">{{fmt1(item._PrezzoEtichetta)}} </td>
      <td class="text-right">{{item._Sconto}} %</td>
   
      <td class="text-right">{{fmt1(item._PrezzoDiVendita)}} </td>
      <td class="text-nowrap">{{item.Store}} </td>
      <td>{{item.Market}} </td>
      
      <td>{{item.EanFornitore}} </td>
      <td>{{item.Provenienza}} </td>
      <td>{{item.orderId}} </td>

    </tr> 
  </tbody>

</table>
</div>
<label  for="cerca"><strong>
  <i  class="fas fa-filter mr-2 mt-3" aria-hidden="true"></i>
    Filtra</strong></label>
<input class="form-control mb-3" type="text" name="query" v-model="filterProduct">

</div>


<div class="col">
  <div class="card ">

  <div class="card-header bg-success text-white">
    <strong>  ANALISI DEI DATI</strong>
  </div>  
  <div class="card-body">

      <ul class="list-group ">
      <li  class="list-group-item d-flex justify-content-between align-items-center" :class="item.Qta == 1 ? 'list-group-item-success' :  'list-group-item-danger'" v-for="item in totals[0]">
      <strong> {{ item.description }} </strong>
      <span class="_float-right"><strong>{{ setFmt(item.total,item.fmt) }}</strong></span>
      </li>
      </ul>
  </div>
  <div class="card-footer ">
    <table class="table table-sm table-bordered">
    <thead class="test">
    <tr>
    <th scope="col">COSTO €</th>
      <th class="text-right" >SC. MIN.</th>
      <th  class="text-right" >SC. MED</th>
      <th class="text-right" >SC. MAS</th>
      <th class="text-right" >MARGINE</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="item in totals[1]">
  
        <td :style="{color:item.Qta == 1 ? 'green' : 'red'}" class="text-left">
          <strong> {{ fmt1(item.total) }}  </strong>
        </td>
        <td  class="text-right table-info">
          <strong> {{ item.min }} % </strong>
        </td>
        <td class="text-right table-warning">
          <strong> {{ item.avg }} % </strong>
        </td>
        <td class="text-right table-primary">
          <strong> {{ item.max }} % </strong>
        </td>
        <td class="text-right table-light">
          <strong> {{ item.delta_margine }}  </strong>
        </td>
        
    </tr>
  </tbody>
</table>

</div>

</div>

<div class="card">
<div class="card-body">

<ul class="list-group list-group-flush">
<li class="list-group-item" v-for="item in totals[2]">
<div class="row">    
<div :style="{fontWeight:'bold'}" class="col-4 text-nowrap">
  {{ item.description }} 
</div>
<div :style="{color:item.Qta == 1 ? 'green':'red',fontWeight:'bold'}" class="col-4 text-right">
  {{ item.total_qta }} 
</div>
<div  :style="{color:item.Qta == 1 ? 'green':'red'}" class="col-4 text-right">
  <strong>{{ setFmt(item.total,item.fmt) }}</strong>
</div>
</div>
</li>
</ul>
</div>
</div>

</div>

</div>


<alert-box style="margin-top:10px" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
</div>

</template>
<script>

import { mapGetters }    from 'vuex';
import fmt               from '@/components/mixins/fmt'
import alertBox          from '@/components/common/AlertBox.vue';
//import jsPDF             from 'jspdf';


export default {

  mixins     : [fmt],
  components : {alertBox},
  props : ['items','totals'],

  data() {
    return {

     
   filterProduct : '',     
   spinnerCSV      : false,
   
   msg             : {

      title     : '',
      body      : '',
      type      : 0

    },
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
    filteredProducts : function () 
      {
        var filterProducts = this.filterProduct && this.filterProduct.toLowerCase()
        var items = this.items
        if (filterProducts) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterProducts) > -1
          })
        })
      }
        return items
     },
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {

    
  },
  created: function() {

    
    
  },
  methods: {
  


  setFmt(value,fmt)  
  {
    if(fmt == 'fmt2')
    {
      return this.fmt2(value)
    }
    else
    {
      return this.fmt1(value)
    }
  },


  exportToCSV()
  {
      
      const header = Object.keys(this.items[0]);
      let csvContent = "data:text/csv;charset=utf-8," 
      let row = ''
      for (let i = 0; i < header.length; i++) {
          row += header[i] + ";";
      }
      csvContent += row + "\r\n";
      
      this.items.forEach(item=> 
      {
        row = ''
        for (let i = 0; i < header.length; i++) {
                
                if(header[i].substring(0, 1) == '_')
                {
                
                  row += this.fmt1(item[header[i]]) + ";"
                }
                else
                {
                  row += item[header[i]] + ";"
                }
                


                }
                csvContent += row + "\r\n";
        });
          
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "Vendite.csv");
            document.body.appendChild(link); // Required for FF

            link.click(); // This will download the data file named "my_data.csv".

   },

    
  
  
  
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 500px;
overflow   : auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}
.list-group-item
{
  font-size: 18px;
}

.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
 /*   background   : hwb(45 4% 9%);  
    color        : black;   
    */
    position     : sticky;
    top          : 0;
    z-index      : 10;
    

 }


 /* tutti gli header */
.table thead th {
 
  color       : rgb(16, 16, 15) !important;
  background  : #a9cbe2 !important;

}

 .test tr:nth-child(1) th{

  background-color : rgb(206, 213, 237) !important;
  color            : rgb(18, 17, 20) !important

}
.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 25px;
    background   :#e9fce9;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  _border-radius : 0 0 0 10px;
}
.table th:last-child
{
  _border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.grp{
  font-size    : 18px;
  color        : darkmagenta;
}
.form-check-label{
  cursor:pointer
}
.btn-export
{
  background-color: saddlebrown;
  color           :whitesmoke
}
.btn-pdf
{
  background-color: blueviolet;
  color           :whitesmoke
}

.card-header
{
  height: 45px;
}
.table-light{
  background-color : orange ;
}
.btn-light{
  background-color: rgb(186, 212, 44)  !important;
}

.table {
  border-collapse: separate;
}

</style>